exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea#answer {\r\n    height: 90px;\r\n}\r\ndiv.has-error {\r\n    color: red !important;\r\n}\r\ndiv.div-question {\r\n    max-height: 250px;\r\n    overflow: auto;\r\n}\r\ndiv.modal-content {\r\n    max-height: 700px;\r\n    overflow: auto;\r\n}\r\npre {\r\n    white-space: pre-wrap;       /* Since CSS 2.1 */\r\n    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */\r\n    white-space: -o-pre-wrap;    /* Opera 7 */\r\n    word-wrap: break-word;       /* Internet Explorer 5.5+ */\r\n    border: none;\r\n    background-color: inherit;\r\n    word-break: normal;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user-questions/reply-question/reply-question.component.css
// module id = ../../../../../src/app/_components/user-questions/reply-question/reply-question.component.css
// module chunks = main